import { RECEIVE_SELF_EMPLOYMENT, REQUEST_SELF_EMPLOYMENT, RESOLVE_SELF_EMPLOYMENT_NAVIGATION } from '../actions'
import { shouldGoToNextAllowanceQuestion, shouldGoToNextQuestion } from '../helpers'

export default (
    state = {
        activeQuestionIndex: null,
        fetchSuccessful: null,
        goToNextAllowanceQuestion: null,
        goToNextQuestion: null,
        isAllowanceUpdate: null,
        shouldFetch: true,
    },
    action
) => {
    const { type, data } = action

    switch (type) {
        case REQUEST_SELF_EMPLOYMENT:
            return { ...state, shouldFetch: false }

        case RECEIVE_SELF_EMPLOYMENT:
            return { ...state, ...data }

        case RESOLVE_SELF_EMPLOYMENT_NAVIGATION:
            return {
                ...state,
                goToNextQuestion: shouldGoToNextQuestion(data),
                goToNextAllowanceQuestion: shouldGoToNextAllowanceQuestion(data),
                isAllowanceUpdate: null,
            }

        default:
            return state
    }
}
